import businessRelation from './businessRelation/text.js';
import company from './company/text.js';
import component from './component/text.js';
import deliveryPoint from './deliveryPoint/text.js';
import entity from './entityText.js';
import equipment from './equipment/text.js';
import role from './role/text.js';
import samaccount from './samaccount/text.js';
import sidebar from './sidebarText.js';
import site from './site/text.js';
import user from './user/text.js';

export default {
  businessRelation,
  company,
  deliveryPoint,
  role,
  samaccount,
  site,
  user,
  equipment,
  sidebar,
  entity,
  component,
};
